<template>
    <div class="container" v-if="config">
        <banner-top :order-now="true"/>
        <payoff style="display: flex; justify-content: center" >
            <img 
                src="https://api.quomi.it/oldimg/Logo-Quomi.png" 
                alt="logo"
                class="quomi-logo"
            >
            <h1
                v-html="config.payoff.title"
            />
            <h3
                v-html="config.payoff.subtitle"
                style="color: white"
            />
            <br>
            <div class='flex-center'>
                <CTA
                    @click="scrollToDivId('more')"
                    isArrowDown
                    :content="`Ordina ora`"
                    :class="headerCtaHover"
                    :style="config.cta_background"
                />
            </div>
            <br> 
            <div class="subtitle" v-if="plansStore.plans">
                <i class="fa fa-check" aria-hidden="true"></i>
                {{config.payoff.subtitle_2}}
                <!-- <s>€ {{ offerPlanPrice }}</s>
                <span>&nbsp;</span>
                <b>€ {{ offerPlanPrice | discounted(config.DISCOUNT) }}</b> -->
            </div>

            <div class="subtitle orange">
                {{config.payoff.subtitle_3}}
            </div>
        </payoff>

<!--    <div class="col-8 col-sm-4 col-md-2 m-auto mb-10 pt-0" v-if="$route.name === 'order-now-voiello'">
            <img src="https://api.quomi.it/oldimg/procida-cover.webp" alt="box">
        </div> -->

        <section class="content-panel" v-if="$route.name === 'order-now-voiello'">
            <h2
                class="center mt-15"
                v-html="`Scopri il contenuto della box`"
            />
            <p class="px-3 pt-5">
                Apri la tua box e assapora le tradizioni della <b>cucina procidana</b>, con due ricette di alta qualità create in collaborazione con <b>Voiello</b>. 
                La box contiene tutti gli ingredienti selezionati e nelle giuste dosi per cucinare lo <b>Spaghetto Scanalato Voiello con pesto procidano di carciofi e limoni, 
                alici e briciole di pane alle erbe della costiera</b> e i <b>Paccheri Voiello con pomodorini del Piennolo del Vesuvio dop, alici e crumble alle erbe del golfo</b>.
            </p>
            <div class="col col-sm-8 m-auto my-10">
                <img src="https://api.quomi.it/oldimg/Box-Voiello-per-Procida-2022.webp" alt="box">
            </div>
            <p class="px-3">
                Un piccolo saggio della generosità di una terra straordinaria, per sostenere l’isola di <b>Procida</b> nell’anno in cui trascende i suoi confini per diventare 
                <b>Capitale italiana della cultura 2022</b>.
            </p>

            <div class="flex flex-wrap flex-center mt-10 align-items-baseline">
                <div class="recipe-preview">
                    <div class="shadow-box pa-0">
                        <img src="https://api.quomi.it/oldimg/Voiello-Procida-spaghetti-1-%281%29.webp" alt="spaghetto"/>
                        <span class="text-bold text-center d-block">Spaghetto Scanalato Voiello con pesto procidano di carciofi e limoni, alici e briciole di pane alle erbe della costiera</span>
                    </div>
                    <div class="pt-5">
                        <h3 class="text-bold">Ingredienti per 5 persone</h3>
                        <ul class="px-5">
                            <li>Lo Spaghetto Scanalato Voiello 500g</li>
                            <li>Pesto di carciofi e limoni 212g</li>
                            <li>Mix peperoncino/aglio/menta/briciole di pane 15g</li>
                            <li>Alici procidane sott’olio in vaso vetro da 140g</li>
                        </ul>
                    </div>
                </div>
                <div class="recipe-preview">
                    <div class="shadow-box pa-0">                   
                        <img src="https://api.quomi.it/oldimg/box-voiello-procida.webp" alt="paccheri"/> 
                        <span class="text-bold text-center d-block px-2">Paccheri Voiello con pomodorini del Piennolo del Vesuvio dop, alici e crumble alle erbe del golfo</span>
                    </div>
                     <div class="pt-5">
                        <h3 class="text-bold">Ingredienti per 5 persone</h3>
                        <ul class="px-5" >
                            <li>Il Pacchero Voiello 500g</li>
                            <li>Mix peperoncino/aglio/menta/briciole di pane 15g</li>
                            <li>Alici procidane sott’olio in vaso vetro da 140g</li>
                            <li>Pomodorino del Piennolo del Vesuvio in acqua e sale 580g</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="content-panel " id="content-panel">
            <h2
                class="center mt-10"
                v-html="`Scopri come funziona`"
            />
                
            <p class="px-3">{{config.how_works.subtitle}}</p>

            <div class="flex wrap">
                <div class="col-sm-4 col-xs-12">
                    <img :src="config.how_works.card_1.img" class="usp-icon" alt="Pianifica le tue cene">
                    <h3 class="text-bold">{{config.how_works.card_1.title}}</h3>
                    <p>{{config.how_works.card_1.subtitle}}</p>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <img :src="config.how_works.card_2.img" class="usp-icon" alt="Ricevi gli ingredienti">
                    <h3 class="text-bold">{{config.how_works.card_2.title}}</h3>
                    <p>{{config.how_works.card_2.subtitle}}</p>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <img :src="config.how_works.card_3.img" class="usp-icon" alt="Prepara piatti deliziosi">
                    <h3 class="text-bold">{{config.how_works.card_3.title}}</h3>
                    <p>{{config.how_works.card_3.subtitle}}</p>
                </div>
            </div>
            <br>
            <hr>

            <div class="ma-5">
                <opinions :order-now="true" :template="'orderNow'"/>
                <div class="feedaty-banner tag-partner">
                    <div class="feedaty_widget" data-type="merchant" data-id="selettore1" data-variant="300x200-4" data-gui="all" data-lang="all" ></div>
                </div>
            </div>

            <hr>
        </section>

        <section id="more" >
            <br>
            <h2 class="center px-2" v-html="config.steps.title"></h2>
            <center>
                <p class="px-1"> <i class="fa fa-check" aria-hidden="true"></i>&nbsp; {{config.steps.subtitle}}</p>
                <div class="alert-people mb-5 py-1">
                    <b>
                        <i class="fas fa-exclamation-triangle pr-1" /> Altre {{ peopleCounter }} persone stanno guardando l'offerta
                    </b>
                </div>
            </center>
        </section>
        
        <div class="checkout-container flex flex-wrap">
            <div class="checkout-panel">
            
                <section>
                    <div class="shadow-box">
                        <div class="section-title" :data-step-number="step['1'].completed ? 0 : 1" id="step4">
                            <h2>{{config.steps.step_title_1}}</h2>
                            <div class="flex-right" @click="step['1'].editedMode = !step['1'].editedMode" v-if="step['1'].completed"><i aria-hidden="true" class="fas fa-pencil-alt" /></div>
                        </div>
                    </div>

                    <div v-if="step['1'].editedMode" class="section-content">
                        <div class="recipes-listing">
                            <div 
                                class="recipe-box recipe-extra-box" 
                                :class="{'box-voiello' : $route.name === 'order-now-voiello'}" 
                                v-for="(product, index) in shop" :key="index"
                            >
                                <extra-box   
                                    :no-ingredients="true"                                                                                
                                    :item="product"
                                    :order.sync="orderStore.order"
                                    @openModalExtra="$refs.modalExtra.open(product)"
                                    :maxAvailable="config.MAX_ITEM"
                                    :style="product.stock <= 0 ? 'opacity: 0.5' : ''"
                                    :productables="true"
                                    :redirect="false"
                                    @scroll-cta="scrollToCta"
                                    :fixed-discount="config.coupon_value"
                                >
                                </extra-box>
                            </div>
                        </div>

                        <!--<div class="recipes-listing">
                            <recipe-box
                              v-for="(item, index) in menu.recipes"
                              :key="`box-${index}`"
                              v-if="item"
                              :item="item"
                              :quantity="$_orderAction_getRecipeQuantity(item)"
                              :availability="getRecipeAvailability(item)"
                              @openRecipe="$refs.recipeModal.open(item)"
                              @recipeAction="recipeAction"
                              :class="{   
                                  'disabled': (isMaxRecipesReached || isOrderHasMixedBox || !order) && !isRecipeInBox(item),
                              }"
                              :isRecipeAvailable="recipeAvailable(item)"
                              :isRecipeInBox="isRecipeInBox(item.id)"
                              :maxReached="isOrderHasMixedBox"
                              isActionAllowed
                              isHover
                              :updating="updating"
                          />
                        </div>

                        <div id="afterRecipesConfirm" />

                    -->

                        <br>
                        <CTA
                            id="confirm"
                            :class="headerCtaHover"
                            :style="config.cta_background"
                            @click="stepRecipes()"
                            :content="`Conferma`"   
                            :disabled="orderStore.order && orderStore.order.extras.length == 0"
                            isWithLoader
                            :loading="stepRecipesLoading"
                        />
                        <p class="mt-3" :style="'color:' + config.cta_background.backgroundColor" v-if="orderStore.order && orderStore.order.extras.length == 0">{{config.addToCartText}}</p>
                    </div>
                </section>

                <section>
                <div class="shadow-box">
                    <div class="section-title" :data-step-number="step['2'].completed ? 0 : 2" id="step2">
                    <h2>{{config.steps.step_title_2}}</h2>
                    <div class="flex-right" @click="step['2'].editedMode = !step['2'].editedMode" v-if="step['2'].completed">
                        <i aria-hidden="true" class="fas fa-pencil-alt" />
                    </div>
                    </div>
                </div>

                <div
                    v-if="step['2'].editedMode"
                    class="section-content"
                >
                <div v-if="user && !user.email.includes('guest.quomi.it')" id="user-panel">
                    <div class="section-content">
                    <div>Ciao, {{ user.firstname }}</div>
                    </div>
                </div>

                <SignUpContent v-else
                    @loginSuccess="stepLogin()"
                    style="max-width: 400px"
                    class="ma-auto"
                />
                </div>
                </section>

                <section id="checkout-subscription">
                    <div class="shadow-box">
                        <div class="section-title" :data-step-number="step['3'].completed ? 0 : 3" id="step3">
                            <h2 style="word-break: break-word">{{config.steps.step_title_3}}</h2>
                            <div class="flex-right" @click="step['3'].editedMode = !step['3'].editedMode"  v-if="step['3'].completed">
                                <i class="fas fa-pencil-alt" />
                            </div>
                        </div>
                    </div>

                    <div v-if="step['3'].editedMode" class="section-content">
                        <div v-if="orderStore.order">
                            <delivery-main 
                                v-if="orderStore.status !== 'confirmed'"
                                class="section-content"
                            >
                                <template
                                    v-slot:cta-global                          
                                >
                                    <CTA
                                        :class="headerCtaHover"
                                        :style="config.cta_background"
                                        isWithLoader
                                        :loading="stepStore.updating.subscription"
                                        :disabled="stepStore.loading.subscription || !shipmentZonesStore.shipmentZones.available.length > 0"
                                        @click="stepDelivery()"
                                        :content="$t('components.checkout.subscription.button')"
                                    />
                                </template>
                            </delivery-main>

                        </div>

                    </div>
                </section>

                <section id="checkout-recurring" v-if="config.recurring">
                    <div class="shadow-box">
                        <div class="section-title" :data-step-number="step['4'].completed ? 0 : 4" id="step4">
                            <h2>{{config.steps.step_title_4}}</h2>
                            <div class="flex-right" @click="step['4'].editedMode = !step['4'].editedMode"  v-if="step['4'].completed">
                                <i class="fas fa-pencil-alt" />
                            </div>
                        </div>
                    </div>

                    <div v-show="step['4'].editedMode" class="section-content">
                        <div v-if="orderStore.order">
                          <!-- <img style='position:absolute; top: 350px;left:-150px' src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fi.stack.imgur.com%2FwzkeT.png&f=1&nofb=1">

                          <img style='width: 100%' src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn-img-p.facciabuco.com%2F41%2Fidgg207nvn-m0q0r_c.jpg&f=1&nofb=1"> -->
                          <subscription-recurring-change v-if="user && user.subscription" :showSkippableDates="false" :config="recurringConfig" :defaultEnabled="true" @hide-paragraph="hideParagraph"/>
                          <p class="py-3" v-show="!noParagraph">Oppure procedi col tuo ordine. Potrai attivare il tuo abbonamento anche successivamente</p>
                            <CTA
                                :class="headerCtaHover"
                                :style="config.cta_background"
                                :content="'Vai alla cassa'" 
                                @click="stepRecurring()"
                                isWithLoader
                                :loading="stepPaymentStore.loading"
                            />
                        </div>

                    </div>
                </section>

                <section id="checkout-payment">
                    <div class="shadow-box">
                        <div class="section-title" 
                            :data-step-number="step['5'].completed ? 0 : (!step['5'].completed && config.recurring ) ? 5 : 4 " 
                            id="step5"
                        >
                            <h2>{{config.steps.step_title_5}}</h2>
                        </div>
                    </div>

                    <div class="section-content" v-if="step['5'].editedMode || step['4'].editedMode ">

                        <payment-methods
                            v-if="user"
                            :mode="'noCoupon'"
                        />

                        <p class="small-text">
                            &#127795; Pianteremo un albero in partnership con “Eden Reforestation Projects” per ogni ordine che effettuerai sul nostro sito.
                        </p>
                            
                        <div class="payment-button-line">
                            <CTA
                                class="mb-3"
                                :class="headerCtaHover"
                                :style="config.cta_background"
                                :content="$t('buttons.confirm_order')"  
                                :disabled="confirmButtonDisabled"
                                @click="stepPayment()"
                                isWithLoader
                                :loading="stepPaymentStore.loading"
                            />
                            
                            <div class="icons">
                                <a href="http://www.consorzionetcomm.it/associazione/chi-siamo/soci/elenco_soci/quomi.kl" target="_blank">
                                    <img src="../../assets/img/netcomm.png" class="netcomm">
                                </a>
                                <img src="../../assets/img/ssl.png" alt='ssl' class="ssl">
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div
                v-if="showBill"
                class="sidebar-panel"
                id="checkout-bill"
                >
                <div
                    is="CheckoutBill"
                    class="sidebar-panel_inner float"
                    :stop="loading['stop']"
                />
            </div>
        </div>

        <general-error />

        <div class="flex flex-column align-items-center mb-5 tag-partner">
				<h3 class="mb-3">{{ $t("components.footer.payment_methods.title") }}</h3>
				<!-- <div class="flex">
					<i class='fab fa-cc-visa fa-3x mr-2'/>
					<i class='fab fa-cc-mastercard fa-3x mr-2'></i>
					<i class='fab fa-cc-paypal fa-3x mr-2'></i>
				</div> -->
                <span class="flex flex-column align-items-center">
					<img src="https://api.quomi.it/oldimg/metodi-pagamento-quomi.webp" alt='$t("components.payment.accepted_cards")' class="w-75">
                    <img class="w-50" :class="{'mt-3' : !$mq.isDesktop()}" src="https://api.quomi.it/oldimg/paypal-quomi.webp" alt='logo paypal'>
				</span>
		</div>
        <div v-if="$route.name === 'order-now-voiello'">
            <h3>{{ $t("components.footer.contacts_widget.title") }}</h3>
            <ul class="contacts">
                <li>
                    <a href="tel:0287156618" title="Tel: 02 87 15 66 18">
                        {{ $t("components.footer.contacts_widget.phone_number") }}
                    </a>
                    <span class="time">{{ $t("components.footer.contacts_widget.week_days") }}
                        <nobr>{{ $t("components.footer.contacts_widget.time") }}</nobr>
                    </span>
                </li>

                <li>
                    <a :href="'mailto:' + $t('components.footer.contacts_widget.email')" :title='$t("components.footer.contacts_widget.email")'>
                        {{ $t("components.footer.contacts_widget.email") }}
                    </a>
                </li>
            </ul>
        </div>

        <bottom-bar />

    </div>
</template>

<script type="text/javascript">

import DeliveryDaySelect from '../Delivery/DeliveryDaySelect'

import SubscriptionForm from '../Delivery/SubscriptionForm'
import RecipeBox from '../RecipeBox'

import ShipmentSelect from '../Delivery/ShipmentSelect'
import DeliveryMain from '../Delivery/DeliveryMain'

import PaymentMethods from './PaymentMethods'
import GeneralError from './GeneralError'
import Checkbox from '../Checkbox'
import Payoff from '../Parts/Payoff'
import BottomBar from '../Parts/BottomBar'
import SignUpContent from '../SignUpContent'

import { container } from '../../services/container'
import { OAuth } from '../../services/oauth'

import { deliveryContainer } from '../../mixins/deliveryContainer'
import { mixedBox } from '../../mixins/mixedBox'

import { Order } from '../../core/Order'

import { scrollToElementId } from '../../assets/js/main'

import { shipmentZonesStore } from '../../store/shipmentZonesStore'
import { subscriptionStore } from '../../store/subscriptionStore'
import { stepPaymentStore } from '../../store/stepPaymentStore'
import { deliveryStore } from '../../store/deliveryStore'
import { errorStore } from '../../store/errorStore'
import { orderStore } from '../../store/orderStore'
import { plansStore } from '../../store/plansStore'
import { menuStore } from '../../store/menuStore'
import { stepStore } from '../../store/stepStore'
import { orderAction } from '../../mixins/orderAction'
import CheckoutBill from './CheckoutBill'
import { ExtraApi } from '../../api/ExtraApi'
import ExtraBox from '../Ecommerce/ExtraBox'
import SubscriptionRecurringChange from './SubscriptionRecurringChange'
import Opinions from '../Opinions'
import BannerTop from '../Parts/BannerTop'

export default {
    components: {
        SubscriptionRecurringChange,
        DeliveryDaySelect,
        SubscriptionForm,
        PaymentMethods,
        ShipmentSelect,
        GeneralError,
        DeliveryMain,
        BottomBar,
        RecipeBox,
        Checkbox,
        Payoff,
        CheckoutBill,
        SignUpContent,
        ExtraBox,
        Opinions,
        BannerTop
    },

    mixins: [
        deliveryContainer,
        mixedBox,
        orderAction,
    ],

    data () {
        return {
            recurringConfig: {
              shop: false,
              recipes: false,
              firstDelivery: false,
              totalPrice: false,
              type: "fast",
              lastHint: false,
              orderNowAboCta: true,
            },
            shop: [],
            shipmentZonesStore: shipmentZonesStore.state,
            stepPaymentStore: stepPaymentStore.state,
            deliveryStore: deliveryStore.state,
            subscriptionStore: subscriptionStore.state,
            errorStore: errorStore.state,
            orderStore: orderStore.state,
            plansStore: plansStore.state,
            menuStore: menuStore.state,
            stepStore: stepStore.state,

            stepRecipesLoading: false,
            stepPlanLoading: false,

            recipes_id: [],

            people: null,
            meals: null,

            paymentCheckbox: false,

            peopleCounter: 11,

            step: {
                1: {
                    completed: false,
                    editedMode: true
                },
                2: {
                    completed: false,
                    editedMode: false
                },
                3: {
                    completed: false,
                    editedMode: false
                },
                4: {
                    completed: false,
                    editedMode: false
                },
                5: {
                    completed: false,
                    editedMode: false
                },
                6: {
                    completed: false,
                    editedMode: false
                }
            },
            loading: {
                stop: false
            },
            noParagraph: null,
            showBill: false,
            checkAbo: false
        }
    },

    filters: {
        discounted (price, discount) {
            if (!price || !discount) return
            // To solve .99999999999999 problem
            return (Math.round((price - discount) * 10) / 10)
                        .toFixed(2)
                        .toString()
                        .replace('.', ',')
                        .replace(',00', '') 

        },

        priceFilter (val) {
            if (!val) return
            return `€ ${Number(val).toFixed(2).toString().replace('.', ',')}`
        },

        deliveryPrice (val) {
            if (val === '0.00') return 'GRATUITA'
            return `€ ${val.replace('.', ',')}`
        }
    },

    watch: {
        'user' (newUser, oldUser) {
            if (this.user && this.user.isSubscribed()) {
                this.$router.push({name: 'flow-subscribed'})
                return
            }

            if (!this.user) {
                for (let key in this.step) {
                    this.step[key].completed = false
                    this.step[key].editedMode = false
                }
                this.step['1'].editedMode = true
            }

            // const loginExecuted = () => { return oldUser === null }
            const logoutExecuted = () => { return newUser === null }

            const loginExecuted = () => { 
                return (oldUser === null || oldUser.email.includes('guest.quomi.it'))
                    && !newUser.email.includes('guest.quomi.it')
            }

            if (loginExecuted() || logoutExecuted()) {
                this.createNewOrder()
            }

            if (this.user && this.user.order) {
                orderStore.state.order = new Order(this.user.order)
            }

            if (this.user && this.user.subscription) {
                subscriptionStore.state.subscription = this.user.subscription
            }
        },

        'menuStore.active': {
            handler () {
                menuStore.redirectHandler()
            },
            immediate: true
        },

        'subscriptionStore.subscriptionParams': {
            handler () {
                errorStore.removeMessage()
            },
            deep: true
        }
    },

    computed: {
        config () {
            return this.$route.meta.config;
        },

        plans () {
            if (!this.plansStore.plans) return []
            return this.plansStore.plans.sort((a, b) => (a.people - b.people))
        },

        recipesDisabled () {
            var plan = plansStore.getPlan(this.people, this.meals)

            return plan && this.recipes_id.length >= plansStore.getMaxRecipes({ plan_id: plan.id })
        },
        user () {
            return this.$root.user
        },

        menu () {
            return this.menuStore.menu
        },

        offerPlanPrice () {
            if (!this.plansStore.plans) return
            return +this.plansStore.plans.find(plan => plan.meals === this.config.MEALS_DEFAULT && plan.people === this.config.PEOPLE_DEFAULT).price
        },

        orderHasDiscount () {
            return this.orderStore.order && this.orderStore.order.discount && this.orderStore.order.discount.amount && this.orderStore.order.discount.amount != 0
        },

        confirmButtonDisabled () {
            var isLoading = this.stepPaymentStore.loading || this.stepStore.updating.subscription
            return isLoading
        },

        address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        delivery () {
            var sub = this.subscriptionStore.subscription
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

        isFP () {
            return this.delivery
                && this.delivery.code
                && this.delivery.code.includes('FP')
        },

        timeRanges () {
            if (!this.deliveryStore.params.timeRange.start || !this.deliveryStore.params.timeRange.end) return ''
            return `(${this.deliveryStore.params.timeRange.start.slice(0, -3)} - ${this.deliveryStore.params.timeRange.end.slice(0, -3)})`
        },
        headerCtaHover() {
            return {
                defaultHover: this.$route.name === 'order-now',
                voielloHover: this.$route.name === 'order-now-voiello'
            }
        }
    },

    methods: {
        scrollToDivId (target) {
            scrollToElementId(target)
        },
        
        recipeAvailable (recipe) {
            return recipe.available || this.isRecipeInBox(recipe)
        },

        isRecipeInBox (recipe) {
            return !!this.recipes_id.find(r => r === recipe.id)
        },
        skipStepUser() {
          if (this.user && !this.user.email.includes('guest.quomi.it')) {

              this.step[1].completed = false
              this.step[1].editedMode = true
              this.step[2].completed = true
              this.step[2].editedMode = false
          }
        },
        load () {
            return plansStore.loadPlans() 

            .then(response => {
                return menuStore.loadCurrentMenu()
            })
        },

        openNextStep () {
            for (let key in this.step) {
                if (this.step[key].completed === false) {
                    this.step[key].editedMode = true
                    this.$nextTick(() => {
                        scrollToElementId(`step${key}`, 300, this.$mq.isDesktop() ? 50 : 20)
                    })
                    return
                }
            }
        },

    isOrderHasMixedBox () {
        return this.boxesInBox >= 1
    },

        stepPlan () {
            this.stepPlanLoading = true
            return orderStore.updateOrder()

            .then(response => {
                this.step['1'].completed = true
                this.step['1'].editedMode = false
                this.openNextStep()

                this.stepPlanLoading = false
            })

            .catch(response => {
                this.stepPlanLoading =false
            })
        },

        selectPlan (plan) {
            var max = plansStore.getMaxRecipes({ plan_id: plan.id })
            this.recipes_id = this.recipes_id.slice(0, max)

            this.people = plan.people
            this.meals = this.recipes_id.length > 0 ? this.recipes_id.length : plan.meals

            plansStore.state.selectedPlanId = plan.id

            orderStore.updateOrderParam({ param: 'plan_id', value: plansStore.getPlan(this.people, this.meals).id })
            orderStore.updateOrderParam({ param: 'recipes_id', value: this.recipes_id })
        },

        stepRecipes () {
            if(this.orderStore.order.extras.length == 0) {
                return
            }
            this.stepRecipesLoading = true 
            var params = this.orderStore.orderParams

            if (params.plan_id) {
                var plan = this.plansStore.plans.find(p => p.id === params.plan_id)

                if (plan.meals !== params.recipes_id.length) {

                    errorStore.updateMessage(`Seleziona ${this.config.MEALS_DEFAULT} ricetta`)
                    this.stepRecipesLoading = false
                    return
                }
            }

            return orderStore.updateOrder()

            .then(response => {
                this.step['1'].completed = true
                this.step['1'].editedMode = false
                this.openNextStep()

                this.stepRecipesLoading = false
            })

            .catch(response => {
                this.stepRecipesLoading = false
                errorStore.formatMessage(response)
            })
        },

        stepRecurring () {
            
            this.step['4'].completed = true
            this.step['4'].editedMode = false
            this.openNextStep()        
        },

        stepDelivery () {
            if(!this.config.recurring) {
                this.step['3'].completed = true
                this.step['3'].editedMode = false
                this.openNextStep()
            }
            
            return stepStore.stepSubscription()
            
            .then(response => {
                stepStore.state.updating.subscription = false
                this.viewBill()
                this.step['3'].completed = true
                this.step['3'].editedMode = false
                this.openNextStep()
            })

            .catch(response => {
                stepStore.state.updating.subscription = false
                errorStore.formatMessage(response)
            })
        },

        stepLogin () {
            this.step['2'].completed = true
            this.step['2'].editedMode = false
            this.openNextStep()
        },

        recipeAction ($event) {
            var recipe = $event.recipe;
            errorStore.removeMessage()

            var savedPrevError = this.errorStore.message
            var savedPrevErrorType = this.errorStore.type

            // block for only one mixed-box
            if (recipe.isMixedBox && this.$_mixedBox_isOrderHasMixedBox({ menu: this.menu, recipes_id: this.recipes_id }) && !this.isRecipeInBox({ id: recipe.id })) {
                errorStore.updateMessage('Puoi inserire una sola cassetta per ordine')
                errorStore.updateType('info')

                setTimeout(() => {
                    savedPrevError
                        ? errorStore.updateMessage(savedPrevError)
                        : errorStore.removeMessage()
                    errorStore.updateType(savedPrevErrorType)
                }, 2000)
                return
            }

            if (this.isRecipeInBox(recipe)) {
                // remove
                var index = this.recipes_id.findIndex(r => r === recipe.id)
                this.recipes_id.splice(index, 1)
            } else {
                // add
                if (this.recipesDisabled) return
                this.recipes_id.push(recipe.id)
            }

            this.meals = this.recipes_id.length

            orderStore.updateOrderParam({ param: 'recipes_id', value: this.recipes_id })
            var plan = plansStore.getPlan(this.people, this.meals)
            if (plan) orderStore.updateOrderParam({ param: 'plan_id', value: plan.id })

            var min = this.config.MEALS_DEFAULT
            if (this.recipes_id.length >= min) orderStore.updateOrder()

            if (plan && this.recipes_id.length >= plansStore.getMaxRecipes({ plan_id: plan.id })) {
                scrollToElementId('afterRecipesConfirm', 300, 100)
            }
            
        },

        createNewOrder() {
            return this.createGuest()

            .then(response => {
                
                orderStore.state.order = this.user ? this.user.order : null
                deliveryStore.reset()

                if (!this.menu) return
                if (!this.menu.active) return

                var plan_id = this.orderStore.orderParams.plan_id
                var recipes_id = this.orderStore.orderParams.recipes_id

                this.people = this.config.PEOPLE_DEFAULT
                this.meals = this.config.MEALS_DEFAULT
                this.recipes_id = []

                if (container.get('services.cookies').get('ref', '/')) container.get('services.cookies').remove('ref')

                orderStore.updateOrderParam({ param: 'plan_id', value: plan_id ? plan_id : plansStore.getPlan(this.people, this.meals).id })
                orderStore.updateOrderParam({ param: 'week_plan_id', value: this.menu.id })
                orderStore.updateOrderParam({ param: 'recipes_id', value: recipes_id && recipes_id.length > 0 ? recipes_id : this.recipes_id })

                orderStore.removeOrderParam({ param: 'shipment_zone_id' })
                orderStore.removeOrderParam({ param: 'shipment_day' })

                return orderStore.updateOrder()
            })

            .then(response => {
                this.afterload()
                return this.$_deliveryContainer_fillSubscriptionParams()
                
            })

            .catch(response => {
                errorStore.formatMessage(response)
            })
        },

        afterSelect () {
            //  do nothing
        },

        stepPayment () {
            errorStore.removeMessage()
            return stepPaymentStore.stepPayment()

            .then(response => {

                if (this.stepPaymentStore.method === 'creditCard') {
                  
                  container.get('source').updateValue('default');

                  this.$router.push({ name: 'thank-you-new' })
                }
            })

            .catch(response => {
                errorStore.formatMessage(response)
                
                var errorCode = response && response.body && response.body.errors
                    ? response.body.errors[0].code
                    : null

                var error = errorCode && errorCode === 'FRAUD_COUPON_DUPLICATE'
                    ? this.$t('api.' + errorCode.toLowerCase().replace(/\s+/g, '_') + '_order_now')
                    : this.errorStore.message

                errorStore.formatMessage(error) 
                
                orderStore.retrieveOrder()
                stepPaymentStore.state.loading = false
            })
        },

        checkboxEvent (val) {
            errorStore.removeMessage()
            this.paymentCheckbox = val
        },

        afterload () {  
            this.$route.params.error
                ? errorStore.updateMessage(this.$route.params.error)
                : errorStore.removeMessage()
            this.addCoupon()
        },

        addCoupon () {
            if (!this.orderStore.order) return
            var params = {
                coupon_code: this.config.coupon
            }

            orderStore.addCoupon(params)
        },

        setPeopleCounter () {
            var min = 11
            var max = 47
            var setter = (Math.random() * (+max - +min) + +min)
            this.peopleCounter = Math.round(setter)
        },

        createGuest () {
            if (this.user) return Promise.resolve()
            return container.get('services.oauth').createGuest()
        },

        loadExtras () {
            var em = new ExtraApi()
            return em.all({
                params: this.config.EXTRA_QUERY
            })
            .then(response => {
                this.shop = response.body.data.resources
                this.shop.sort((a,b) => {
                    return a.price - b.price
                })
            })
        },

        hideParagraph(value) {
            this.noParagraph = value;
        },

        scrollToCta() {
            this.scrollToDivId('confirm')
        },

        viewBill() {
            return this.showBill = true
        },

        activateAbo() {
            return this.checkAbo = true
        }
    },

    mounted () {
        const feedatyPlugin = document.createElement("script");
        feedatyPlugin.setAttribute("src", "https://widget.feedaty.com/public/js/feedaty.js?merchant=10214294&style_ver=2021");
        feedatyPlugin.async = true;
        document.head.appendChild(feedatyPlugin);

        if (this.user && this.user.source === 'default') {
            this.$router.push('/checkout/scegli-ricette')
            return;
        }  

        let param = 'order-now'
        this.skipStepUser();

        container.get('services.cookies').set('user_source_track', param, 7);
        container.get('source').updateValue(param);

        this.setPeopleCounter()
            return this.load()
        .then(response => {
            return this.createNewOrder()
        })
        .then(response => {
            return this.loadExtras()
        })
        .catch(response => {
            errorStore.formatMessage(response)
        })
    },

    created() {
        var cookies = container.get('services.cookies')
        cookies.set('user_source_track', 'order-now', 7)

        window.addEventListener('recurring-updated', (e) => {
            orderStore.retrieveOrder()
        });
    },

    destroyed() {
      window.addEventListener('recurring-updated', (e) => {
        orderStore.retrieveOrder()
      });
    }
}

</script>

<style scoped> 
.disabled-label {
    color: red;
    font-size: 15px;
}

h1 {
    font-size: 30px;
}

h2, h3 {
    text-align: center;
}
.plan {
    padding: 20px;
    text-align: center;
    margin: 20px 10px;
    cursor: pointer;
    flex-grow: 1;
    max-width: 250px;
}

.plan .plan-title {
    font-size: 26px;
    font-weight: 500;
}

.plan .plan-people {
    font-size: 20px;
}
* >>> .btn,
* >>> .btn:hover {
    margin: 0 auto;
}

* >>> .delivery-list {
    margin: 0 auto;
}

.orange {
    color: orange;
    font-weight: bold;
}

.float {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
}

.usp-icon {
    width: 100%;
    margin-bottom: 20px;
}

.alert-people {
    border-radius: 4px;
    max-width: 392px;
    background: var(--quomi-orange-hover);
    color: white;
    margin: 0 10px;
}

.alert-people .fas {
    font-size: 12px;
    vertical-align: 1px;
}

.payment-icons {
    display: flex;
    justify-content: center;
    align-items: center;
}
.payment-icons img {
    height: 40px;
}

.payment-icons .paypal-icon {
    height: 30px;
}
.flex-right {
    text-align: right;
}

.fa-pencil-alt {
    cursor: pointer;
}

.fa-check {
    color: var(--quomi-primary);
}

.subtitle {
    padding-top: 10px;
    position: relative;
    font-size: 18px;
    color: white;
}

.checkout-container {
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px 30px 20px;
}

.checkout-container section {
    padding: 10px;
}

.content-panel {
    max-width: 1000px;
    margin: 20px auto;
    text-align: center;
}

.checkout-panel {
    flex-basis: calc(100% - 400px);
    border-radius: 6px;
    background-color: white;
    align-self: flex-start; 
    text-align: center;
    width: 100%;
    word-break: break-all;
}

.section-title:before {
    content: attr(data-step-number);
    border: 3px solid var(--quomi-darkgrey);
    flex-basis: 25px;
    min-width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -41px;
    margin-right: 15px;
    color: var(--quomi-darkgrey);
    font-weight: 700;
}

.section-title {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 10px 30px 10px 55px;
    align-items: center;
    background-color: white;
    border-radius: 4px;
}

.section-title h2 {
    margin-bottom: 0;
    text-align: left;
}

.section-content {
    margin: 20px 5px;
}

.section-content >>> #section-shipment {
    text-align: left;
    max-width: 500px;
    margin: 0 auto;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    padding: 25px 0;
}

.section-content >>> #section-shipment hr:first-child {
    display: none;
}

.section-content >>> .delivery-option {
    margin-right: auto;
    margin-left: auto;
    text-align: left;
}

.section-content >>> .flex-fill {
    flex-grow: unset !important;
}

[data-step-number="0"] {
    border: 3px solid var(--quomi-primary);
}

[data-step-number="0"]:before {
    color: #fff;
    border-color: var(--quomi-primary);
    content: '\f00c';
    font-family: 'FontAwesome';
    background-color: var(--quomi-primary);
}

.sidebar-panel {
    padding-left: 25px;
    width: 400px;
    padding-bottom: 40px;
    position: relative;
}

.sidebar-panel_inner {
    border-radius: 6px;
    background-color: #fbf1d7;
    padding: 25px;
    min-height: 150px;
}

.icons {
    padding: 10px 0;
}

.section-recipes {
    max-width: 1000px;
    margin: 0 auto;
}

.recipes-listing {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 -10px;
    align-items: flex-start;
}

.recipe-box,
.recipe-preview {
    text-align: left;
    flex-basis: calc(100% / 3 - 10px);
    max-width: calc(100% / 3 - 10px);
    margin: 5px;
}

.recipe-box.disabled {
    opacity: 0.5;
}

.recipe-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

#checkout-bill  h3 {
    font-weight: bold;
    margin-bottom: 30px;
    text-align: left;
}

#checkout-bill  h4 {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
}

.small-text {
    font-size: 13px;
    padding-top: 6px;
}

.quomi-logo {
    max-width: 10%; 
    position: absolute; 
    top: 1%; 
    right: 45%;
}

.feedaty-banner {
	display: flex;
	justify-content: center;
	background: var(--quomi-bg);
}

.defaultHover:hover {
    background: var(--quomi-primary-hover) !important;
}

.voielloHover:hover {
    background:  #012169 !important;
}

.contacts {
    list-style: none;
	margin: 0 0 10px 0;
    text-align: center;
}

.contacts .time {
		font-size: 13px;
	}

.contacts  a {
		display: block;
	}

.contacts a:hover {
		color: #cbbba2;
		text-decoration: underline;
        font-weight: bold;
}

@media (max-width: 1024px) {
    .recipe-box,
    .recipe-preview {
        flex-basis: calc(100% / 2 - 10px);
        max-width: calc(100% / 2 - 10px);
    }

    .box-voiello {
        flex-basis: calc(50%);
        max-width: 100%;
    }

    * >>> #payoff {
        background-position: center 100%;
    }

    .subtitle {
        font-size: 16px;
    }

    .checkout-panel{
        flex-basis: 100%;
    }

    .sidebar-panel {
        flex-basis: 100%;
        padding-top: 30px;
        padding-left: 0;
        margin: 0 20px 20px 20px;
    }
}

@media (max-width: 600px) {
/*     .recipes-listing {
         width: 70vw;
         margin: 0 auto;
    } */

    .recipe-box {
        flex-basis: calc(100% / 2 - 10px);
        max-width: calc(100% / 2 - 10px);
    }

    .recipe-preview {
        flex-basis: 90%;
        max-width: 90%;
    }

    div > .recipe-preview:first-child {
        margin-bottom: 30px;
    }

    .box-voiello {
        flex-basis: calc(80%);
        max-width: 100%;
    }

    .alert-people {
        font-size: 13px;
    }

    .extra-box >>>  .extra-price {
        position: unset !important;
    }

    .extra-box >>> .extra-title.trunced {
        height: 40px;
    }

    .extra-box >>> .extra-action {
        margin-top: 10px;
    }

    .section-title h2  {
        font-size: 13px;
    }
}

@media(max-width: 768px) {
    .quomi-logo {
        max-width: 25%;
        right: 40%;
    }

    #payoff  h1 {
        margin-top: 30px;
    }
}
</style>
